
export default {
  "en": {
    "popItSetupCustomerManagement": "Customer Management",
    "popItSetupTitle": "Product Title",
    "popItSetupTitleJP": "Product Title (Japanese)",
    "popItSetupOdds": "Odds",
    "popItSetupOddsHelp": "Example: 1 in 100 chance of winning",
    "popItSetupExpireDays": "Number of days to expire",
    "popItSetupPriority": "Priority",
    "popItSetupCategory": "Category",
    "popItSetupQuantity": "Quantity",
    "popItSetupPopitProducts": "Popit Products",
    "popItSetupTotalRedeemed": "Total Redeemed",
    "popItSetupTerms": "Terms and Conditions",
    "popItSetupYes": "Yes",
    "popItSetupNo": "No",
    "popItSetupIsClosed": "Is Closed",
    "popItSetupIsNightStart": "Night Hour Start (optional)",
    "popItSetupNightEnd": "Night Hour End (optional)",
    "popItSetupBusinessImage": "Main Photo",
    "popItSetupContactInformation": "Contact Information",
    "popItSetupContactPhone": "Phone Number",
    "popItSetupContactEmail": "Email Address",
    "popItSetupCustomerSignEmail": "Email Address",
    "popItSetupCustomerSignPassword": "Password",
    "popItSetupContactWebsite": "Website",
    "popItSetupPhotos": "Header Photos",
    "popItSetupMisc": "Misc Photos",
    "popItSetupLongitude": "Longitude",
    "popItSetupLatitude": "Latitude",
    "popItSetupDescription": "Description",
    "popItSetupHolidays": "Holidays",
    "popItSetupBusinessName": "Business Name",
    "popItSetupAddress": "Address",
    "popItSetupCity": "City",
    "popItSetupState": "Prefecture",
    "popItSetupZip": "Zip",
    "popItSetupCategories": "Business Categories",
    "popItSetupCountry": "Business Categories",
    "popItSetupHours": "Hours",
    "popItSetupCoordinates": "Coordinates",
    "popItSetupMonday": "Monday",
    "popItSetupTuesday": "Tuesday",
    "popItSetupWednesday": "Wednesday",
    "popItSetupThursday": "Thursday",
    "popItSetupFriday": "Friday",
    "popItSetupSaturday": "Saturday",
    "popItSetupSunday": "Sunday",
    "popItSetupMaxTicketCount": "Max Ticket Count",
    "popItSetupShowOnWinning": "(Shown on the winning/losing screen)",
    "popItSetupStart": "Start",
    "popItSetupEnd": "End",
    "popItSetupCustomerSignin": "Login Information",
    "popItSetupContactTitle": "Contact",
    "popItSetupSocial": "Social",
    "popItSetupMenuPhotos": "Menu Photos",
    "popItSetupQuantityToRedeem": "Visits Needed To Redeem",
    "popItSetupPunchCardProducts": "Punchcard Products",
    "popItSetupEnabled": "Enabled",
    "popItSetupDaysToRedeem": "Days To Redeem",
    "Stop": "Stop",
    "popToWin": "Pop It To Win",
    "youWon": "You Won!",
    "from": "From",
    "redeemNow": "Redeem Now",
    "saveForLater": "Save For Later",
    "mustBeRedeemedWithinDays": "Must be redeemed within {dayCount} days",
    "oneVisitCloser": "You also are {dayCount} visit closer to",
    "readyToRedeem": "Are you sure you are ready to redeem now?",
    "ifSoShowThis": "If so, show this to a staff member",
    "confirmStaffMember": "Confirm a staff member has seen your device",
    "cancel": "Cancel",
  },
  "jp": {
    "popItSetupCustomerManagement": "顧客管理",
    "popItSetupTitle": "商品タイトル -- Chihiro",
    "popItSetupTitleJP": "商品タイトル (Japanese) -- Chihiro",
    "popItSetupOdds": "オッズ -- Chihiro",
    "popItSetupMenuPhotos": "メニュー写真 -- Chihiro",
    "popItSetupOddsHelp": "たとえば、100分の1の確率で勝つ -- Chihiro",
    "popItSetupExpireDays": "有効期限の日数 -- Chihiro",
    "popItSetupPriority": "優先度",
    "popItSetupCategory": "カテゴリー",
    "popItSetupPopitProducts": "Popitの製品 -- Chihiro",
    "popItSetupQuantity": "量 -- Chihiro",
    "popItSetupTotalRedeemed": "合計償還 -- Chihiro",
    "popItSetupTerms": "条項",
    "popItSetupYes": "はい",
    "popItSetupNo": "番号",
    "popItSetupDescription": "説明文",
    "popItSetupIsClosed": "閉じています",
    "popItSetupMaxTicketCount": "最大チケット数",
    "popItSetupNightStart": "夜間営業時間（オプション） -- Chihiro",
    "popItSetupNightEnd": "夜の時間終了（オプション） -- Chihiro",
    "popItSetupBusinessImage": "ロゴまたはビジネス画像",
    "popItSetupContact": "連絡先",
    "popItSetupContactPhone": "電話番号",
    "popItSetupCoordinates": "コーディネート",
    "popItSetupContactEmail": "電子メールアドレス",
    "popItSetupContactWebsite": "ウェブサイト",
    "popItSetupPhotos": "ピクチャー",
    "popItSetupDaysToRedeem": "交換する日",
    "popItSetupMisc": "Miscellaneous -- chihiro",
    "popItSetupLongitude": "経度 -- chihiro",
    "popItSetupLatitude": "緯度",
    "popItSetupHolidays": "祝日 -- chihiro",
    "popItSetupBusinessName": "商号",
    "popItSetupAddress": "住所",
    "popItSetupCity": "市",
    "popItSetupState": "都道府県",
    "popItSetupZip": "郵便記号",
    "popItSetupCategories": "事業区分 -- chihiro",
    "popItSetupCountry": "国",
    "popItSetupHours": "時間",
    "popItSetupMonday": "月曜",
    "popItSetupTuesday": "火曜日 -- chihiro",
    "popItSetupShowOnWinning": "受賞ページに表示 -- chihiro",
    "popItSetupStart": "開始 -- chihiro",
    "popItSetupEnd": "終わり",
    "popItSetupWednesday": "水曜日 -- chihiro",
    "popItSetupThursday": "木曜日 -- chihiro",
    "popItSetupFriday": "金曜日 -- chihiro",
    "popItSetupSaturday": "土曜日",
    "popItSetupSunday": "日曜日",
    "popItSetupCustomerSignEmail": "電子メールアドレス",
    "popItSetupCustomerSignPassword": "パスワード -- chihiro",
    "popItSetupCustomerSignin": "ログイン情報",
    "popItSetupContactTitle": "連絡先",
    "popItSetupSocial": "ソーシャルネットワーク",
    "popItSetupContactInformation": "連絡先",
    "popItSetupQuantityToRedeem": "引き換える数量 -- chihiro",
    "popItSetupPunchCardProducts": "カード製品 -- chihiro",
    "popItSetupEnabled": "有効化 -- chihiro",
    "Stop": "やめる",
    "popToWin": "ポップ・トゥ・トゥ・ウィン -- Chihiro",
    "youWon": "勝った！-- chihiro",
    "from": "から",
    "redeemNow": "今すぐ交換",
    "saveForLater": "後で見るように保存",
    "mustBeRedeemedWithinDays": "{dayCount}日以内に引き換える必要があります",
    "oneVisitCloser": "あなたも{dayCount}回の訪問に近い -- chihiro",
    "readyToRedeem": "今すぐ交換する準備ができていますか? -- chihiro",
    "ifSoShowThis": "もしそうなら、これをスタッフに見せてください -- chihiro",
    "confirmStaffMember": "スタッフがデバイスを見たことを確認する -- chihiro",
    "cancel": "キャンセル -- chihiro",
  }
}


// WEBPACK FOOTER //
// ./src/components/system/i18n.js